import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import { errorForBanner } from "@shared/v2/ErrorBanner";

const DeleteSourceModal = ({ source, error, onDelete, onHide }) => {
  const [deleting, setDeleting] = useState(false);

  const onConfirm = () => {
    setDeleting(true);
    // `onDelete` settles either way -- on failure the modal stays open to show
    // the error banner, so the button has to come back out of its loading state.
    Promise.resolve(onDelete()).finally(() => setDeleting(false));
  };

  return (
    // Dismissal is blocked while the delete is in flight. Closing early would let a
    // second source be opened before the first settles, and the first request's
    // outcome -- its error banner, its loading state, its close -- would land on
    // whichever source the modal is showing by then.
    <Modal
      show={Boolean(source)}
      onHide={onHide}
      closeOnEscape={!deleting}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header
        title="Delete Source"
        description="Are you sure you want to delete this source?"
        errors={error ? [errorForBanner(error)] : []}
        closeButton={!deleting}
      />
      <Modal.Footer className="tw-flex tw-justify-between">
        <Button size="medium" schema="tertiary" disabled={deleting} onClick={onHide}>
          Cancel
        </Button>
        <Button size="medium" schema="warning" isLoading={deleting} onClick={onConfirm}>
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteSourceModal.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  error: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

DeleteSourceModal.defaultProps = {
  source: null,
  error: null,
};

export default DeleteSourceModal;
